import { render, staticRenderFns } from "./AddStockout.vue?vue&type=template&id=667d6a12&scoped=true"
import script from "./AddStockout.vue?vue&type=script&lang=js"
export * from "./AddStockout.vue?vue&type=script&lang=js"
import style0 from "./AddStockout.vue?vue&type=style&index=0&id=667d6a12&prod&scoped=true&lang=css"
import style1 from "./AddStockout.vue?vue&type=style&index=1&id=667d6a12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d6a12",
  null
  
)

export default component.exports